<script lang="ts" setup>
import { computed } from 'vue';
import { pxOrValue } from '@/ui-kit';

type Props = {
  maxHeight?: number | string;
  minHeight?: number | string;
  height?: number | string;
  strict?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  maxHeight: undefined,
  minHeight: undefined,
  height: '100%',
  strict: false,
});

const styles = computed(() => ({
  maxHeight: pxOrValue(props.maxHeight),
  minHeight: pxOrValue(props.minHeight),
  height: pxOrValue(props.height),
}));
</script>

<template>
  <div :class="$style.root" :style="styles">
    <div :class="$style.header">
      <slot name="header" />
    </div>
    <div :class="$style.body">
      <div v-if="props.strict" :class="$style.viewport">
        <slot />
      </div>
      <slot v-else />
    </div>
    <div :class="$style.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<style module>
.root {
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
}

.header {
  position: relative;
  box-sizing: border-box;
}

.body {
  position: relative;
  box-sizing: border-box;
}

.footer {
  position: relative;
  box-sizing: border-box;
}

.viewport {
  position: absolute;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
